import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

const TimelineSidebar = ({
  timeline,
  metrics,
  setZoomRange,
  selectedIndex,
  setSelectedIndex,
}) => {
  const treatmentSpacing = timeline.map((item, i) => {
    const total = metrics.length;
    const blockSize = total / timeline.length;
    return {
      ...item,
      xStart: Math.floor(i * blockSize),
      xEnd:
        i === timeline.length - 1
          ? metrics.at(-1)?.time
          : Math.floor((i + 1) * blockSize),
    };
  });

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2 className="sidebar-title">Treatment History</h2>
      </div>

      <VerticalTimeline>
        {timeline.map((item, index) => {
          const treatment = treatmentSpacing[index];
          const isSelected = selectedIndex === index;

          return (
            <VerticalTimelineElement
              key={index}
              date={item.start.split("T")[0]}
              iconStyle={{
                background: isSelected ? "#4f46e5" : "#7c3aed",
                color: "#fff",
                boxShadow: isSelected ? "0 0 0 4px #c7d2fe" : "none",
                transition: "box-shadow 0.2s ease",
              }}
              contentStyle={{
                background: "transparent",
                borderBottom: isSelected ? "4px solid #CF9FFF	" : "4px solid transparent",
                borderRadius: "4px",
                padding: "12px 16px",
                transition: "border-color 0.2s ease",
              }}
              contentArrowStyle={{ borderRight: "7px solid transparent" }} // removes arrow
              onTimelineElementClick={() => {
                setZoomRange([treatment.xStart, treatment.xEnd]);
                setSelectedIndex(index);
              }}
            >
              <h3 style={{ marginBottom: 6 }}>{item.name}</h3>
              <p style={{ margin: 0 }}>
                <strong>Treatment:</strong> {item.reason || "N/A"}
              </p>
              <p style={{ margin: 0 }}>
                <strong>Status:</strong> {item.status}
              </p>
            </VerticalTimelineElement>
          );
        })}
      </VerticalTimeline>
    </div>
  );
};

export default TimelineSidebar;
